import { call, put, take, select, race, delay } from "redux-saga/effects"

import api from "apis"

import { SET_CART, REMOVE_ADDON, setCart } from "../actions"

export default function* applyCartChanges(action) {
  let { api_url, method, payload = {} } = action

  try {
    if (action.toggleDisableActions) {
      action.toggleDisableActions(action.variable)
    }

    if (
      action.type === REMOVE_ADDON &&
      !payload.addon_id &&
      action.addon_code
    ) {
      // Wait for the next cart update to get the ID
      const { timeout } = yield race({
        cartUpdated: take(SET_CART),
        timeout: delay(5000),
      })

      if (timeout) return

      const state = yield select((state) => state.cart)
      const addon = (state.addons || []).find(
        (a) => a.addon_code === action.addon_code && !!a.id
      )
      if (addon) {
        payload.addon_id = addon.id
        api_url = api_url.replace("undefined", addon.id)
      } else {
        // If still no ID, we can't proceed.
        return
      }
    }

    const result = yield call(api[method], api_url, {
      ...payload,
    })
    if (result) {
      // begin this is for investigate random cart empty issue after add free gift
      // console.log(
      //   `cart_token: ${Cookies.get(
      //     sl.config.cookies_config.cart_token
      //   )} ${method.toUpperCase()}: ${api_url} result`,
      //   result
      // )
      // end this is for investigate random cart empty issue after add free gift

      yield put(setCart(result.data))

      if (action.callbacks?.onSuccess) {
        action.callbacks.onSuccess()
      }
    }
  } catch (error) {
    // noop
    console.log(error)
    if (action.callbacks?.onError) {
      action.callbacks?.onError(error)
    }
  } finally {
    if (action.toggleDisableActions) {
      action.toggleDisableActions({ action: "", id: "" })
    }
  }
}
